import { Component, EventEmitter, Output } from '@angular/core';
import { TipoAcao } from '../../gerais/models/tipo-acao';
import { CadastrosGeraisService } from '../../services/cadastros-gerais.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-novo-tipo-acao',
  templateUrl: './novo-tipo-acao.component.html',
  styleUrls: ['./novo-tipo-acao.component.css'],
  standalone: false
})
export class NovoTipoAcaoComponent {
  @Output() fecharModalCalled = new EventEmitter();
  @Output() atualizarListaCalled = new EventEmitter();

  showModalTipoAcao = false;
  tipoAcao = new TipoAcao();
  loading = false;

  constructor(
    private cadastrosGeraisService: CadastrosGeraisService,
    private toastr: ToastrService
  ) {}

  showModal() {
    this.tipoAcao = new TipoAcao();
    this.showModalTipoAcao = true;
  }

  fecharModal() {
    this.showModalTipoAcao = false;
    this.fecharModalCalled.emit();
  }

  salvar() {
    if (!this.tipoAcao.descricao) {
      this.toastr.error("A descrição do tipo de ação é obrigatória.");
      return;
    }

    this.loading = true;
    this.cadastrosGeraisService.adicionarTipoAcao(this.tipoAcao).subscribe(
      response => {
        this.loading = false;
        if (response.sucesso) {
          this.toastr.success("Tipo de ação salvo com sucesso");
          this.atualizarListaCalled.emit();
          this.fecharModal();
        } else {
          this.toastr.error("Erro ao salvar o tipo de ação: " + response.errors[0].mensagem);
        }
      },
      error => {
        this.loading = false;
        this.toastr.error("Erro ao salvar o tipo de ação");
      }
    );
  }
}
